var _excluded = ["children", "className", "hint", "label", "multiple", "onChange", "required", "rules", "selectedValues", "validationState", "small", "medium"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useContext, useEffect, useState } from "react";
import AFieldBase from "../AFieldBase";
import { AFormContext } from "../AForm";
import AButtonGroupContext from "./AButtonGroupContext";
import "./AButtonGroup.scss";
var buttonGroupCounter = 0;
var AButtonGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    hint = _ref.hint,
    label = _ref.label,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    onChange = _ref.onChange,
    required = _ref.required,
    rules = _ref.rules,
    selectedValues = _ref.selectedValues,
    _ref$validationState = _ref.validationState,
    validationState = _ref$validationState === void 0 ? "default" : _ref$validationState,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$medium = _ref.medium,
    medium = _ref$medium === void 0 ? false : _ref$medium,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(buttonGroupCounter++),
    _useState2 = _slicedToArray(_useState, 1),
    buttonGroupId = _useState2[0];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(validationState),
    _useState6 = _slicedToArray(_useState5, 2),
    workingValidationState = _useState6[0],
    setWorkingValidationState = _useState6[1];
  var _useContext = useContext(AFormContext),
    register = _useContext.register,
    unregister = _useContext.unregister;
  useEffect(function () {
    setWorkingValidationState(validationState);
  }, [validationState]);
  useEffect(function () {
    if (register) {
      register("a-button-group_".concat(buttonGroupId), {
        reset: reset,
        validate: validate
      });
    }
  }, [validationState, selectedValues, rules]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (unregister) {
      return function () {
        return unregister("a-button-group_".concat(buttonGroupId));
      };
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var validate = function validate() {
    var testValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedValues;
    if (rules || required) {
      var workingRules = [];
      if (rules) {
        workingRules = _toConsumableArray(rules);
      }
      if (required) {
        workingRules = [{
          test: function test(v) {
            return v.length > 0 || "".concat(label ? label + " is r" : "R", "equired");
          },
          level: "danger"
        }].concat(_toConsumableArray(workingRules));
      }
      setWorkingValidationState("default");
      setError(null);
      for (var i = 0; i < workingRules.length; i++) {
        var _error = workingRules[i].test(testValue);
        if (_error !== true) {
          setError(_error);
          setWorkingValidationState(workingRules[i].level || "danger");
          return {
            message: _error,
            level: workingRules[i].level || "danger"
          };
        }
      }
    }
  };
  var reset = function reset() {
    setWorkingValidationState(validationState);
    setError("");
  };
  var className = "a-button-group";
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  if (small) {
    className += " a-button-group--small";
  } else if (medium) {
    className += " a-button-group--medium";
  }
  var buttonGroupContext = {
    selectedValues: selectedValues,
    toggleValue: function toggleValue(toggledValue) {
      var newSelectedValues = selectedValues.includes(toggledValue) ? selectedValues.filter(function (x) {
        return x !== toggledValue;
      }) : multiple ? selectedValues.concat([toggledValue]) : [toggledValue];
      validate(newSelectedValues);
      onChange && onChange(toggledValue, newSelectedValues);
    }
  };
  return /*#__PURE__*/React.createElement(AFieldBase, _extends({}, rest, {
    ref: ref,
    className: className,
    label: label,
    error: error,
    hint: hint,
    validationState: workingValidationState
  }), /*#__PURE__*/React.createElement("div", {
    className: "a-button-group__wrapper"
  }, /*#__PURE__*/React.createElement(AButtonGroupContext.Provider, {
    value: buttonGroupContext
  }, children)));
});
AButtonGroup.propTypes = {
  /**
   * Sets the hint content.
   */
  hint: PropTypes.node,
  /**
   * Sets the label content.
   */
  label: PropTypes.node,
  /**
   * Toggles whether multiple buttons can be selected.
   */
  multiple: PropTypes.bool,
  /**
   * Handles the event when button selection has changed.
   * @param {String} targetValue The toggled button's value.
   * @param {Array} allSelectedValues An array of all selected button values.
   */
  onChange: PropTypes.func,
  /**
   * Sets an array of selected values.
   */
  selectedValues: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.number)]),
  /**
   * Applies a validation state.
   */
  validationState: PropTypes.oneOf(["default", "warning", "danger"]),
  /** Magnetic small sizing */
  small: PropTypes.bool,
  /** Magnetic medium sizing */
  medium: PropTypes.bool
};
AButtonGroup.displayName = "AButtonGroup";
export default AButtonGroup;